



















import AnnotationListItem from "@/edinet/annotation/AnnotationListItem.vue"
import {AnnotationState} from "@/edinet/annotation/store"
import {XbrlAnnotation} from "@/edinet/annotation/types"
import {isGoogleTranslated} from "@/edinet/libs/utils_jq"
import CollapsibleGroup from '@/edinet/components/CollapsibleGroup.vue'
import Vue from 'vue'
import {mapState} from "vuex"

//may need to do this if typescript complains about unsubscribe property in Vue type
declare module 'vue/types/vue' {
  interface Vue {
    updatePageTranslate: (e: Event) => void
    observer: MutationObserver
  }
}

const instance = Vue.extend({
  components: {CollapsibleGroup, AnnotationListItem},
  props: {
    sym: String,
    enableHighlight: Boolean
  },
  data: function() {
    return {
      isPageTranslated: isGoogleTranslated(),
      showAll: false
    }
  },
  computed: {
    ...mapState('annotations', {
      annotations: state => (state as AnnotationState).data
    }),
    totalCount: function(): number {
      return this.displayAnnotations.length
    },
    displayAnnotations: function(): XbrlAnnotation[] {
      const displays = this.annotations.filter(x => x.isTranslated === this.isPageTranslated)
      if (this.showAll) {
        return displays
      } else {
        return displays.filter(x => x.tags.length || x.comment !== "")
      }
    },
    header: function(): string {
      return 'Annotations ' + (this.isPageTranslated ? '(translated) ' : '') + '(' + this.totalCount + ')'
    }
  },
  mounted() {
    this.observer = new MutationObserver(() => {
      if (document.documentElement.className.match('translated')) {
        this.isPageTranslated = true
        // this.scanAndSetupAnnotations()
        const SetupDelay = 1000
        setTimeout(this.setupAnnotations, SetupDelay) //need to wait for translation of the current text to complete before setup
      } else {
        this.isPageTranslated = false
        this.setupAnnotations()
      }
    })
    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false
    })
  },
  destroyed() {
    this.observer.disconnect()
  },
  methods: {
    setupAnnotations: function() {
      this.$emit('forceSetup')
    },
    scanAndSetupAnnotations: function() { //to pre-translate document so that we can highlight annotations
      //remember current position
      const pos = document.documentElement.scrollTop
      //start from top
      let y = 0
      const bottom = document.body.scrollHeight
      window.scrollTo(0, y)
      const SleepMs = 200
      const ScanStep = 1000
      const SetupDelay = 1000

      const rec = () => {
        // console.log('scanning ' + y)
        y += ScanStep
        if (y < bottom) {
          window.scrollTo(0, y)
          setTimeout(rec, SleepMs)
        } else {
          //go back to current
          window.scrollTo(0, pos)
          setTimeout(() => {
            this.setupAnnotations()
          }, SleepMs) //need some delay to wait for translation
        }
      }

      setTimeout(rec, SetupDelay)
    },
    open: function() {
      window.open('/edinet/annotation-viewer/' + this.sym)
    }
  }
})

export default instance
